import styled from 'styled-components';

import { BG_IMG_LG, QR_CODE } from 'appLanding/enums/appLandingPageEnums';
// import { breakpoints } from 'styles/theme/breakpoints';
import { Image } from 'shared/components/Image';
// import { MobileWistiaVideoPlayer } from 'appLanding/components/MobileWistiaVideoPlayer';
// import { useWindowSize } from 'shared/hooks/useWindowSize';
import { variableFontRegular } from 'styles/theme/text';
// import { WistiaVideoPlayer } from 'appLanding/components/WistiaVideoPlayer';
import { t } from 'localization/utils/t';

const TP = 'appLanding.components.AppVideo';

export const AppVideo = () => {
  // const { windowSize } = useWindowSize();
  // const isMinWidthMedium = windowSize.width > breakpoints.medium && !document.fullscreenElement;

  return (
    <AppVideo.Content>
      <AppVideo.Copy>
        <AppVideo.Heading data-qa="app_video_heading">
          {t(`${TP}.heading`, 'DROPPING SOON: GOAT EXCLUSIVE TOTAL 90s')}
        </AppVideo.Heading>
        <AppVideo.SubHeading data-qa="app_video_subheading">
          {t(
            `${TP}.subHeading`,
            `Get ready. The 'Beautiful Game' Total 90s release on Tuesday,  July 14
at 10 AM PT. Limited to 300 pairs worldwide, design highlights include
1-of-1 woven uppers, metallic gold football charms and glow-in-the-dark outsoles. Dropping only on the GOAT app.`,
          )}
        </AppVideo.SubHeading>
        {/* {!isMinWidthMedium ? <MobileWistiaVideoPlayer /> : <WistiaVideoPlayer />} */}
        <AppVideo.QrCodeWrapper>
          <AppVideo.QrCodeText data-qa="app_video_qr_code_text">
            {t(`${TP}.qrCodeText`, 'Scan the QR code to download')}
          </AppVideo.QrCodeText>
          <AppVideo.QrCode
            data-qa="app_video_qr_code"
            src={QR_CODE}
            alt={t(`${TP}.qrCodeDownload`, 'QR code to download app')}
            sizes="75px"
          />
          <AppVideo.QrCodeDisclaimer data-qa="app_video_qr_code_disclaimer">
            {t(
              `${TP}.qrCodeDisclaimer`,
              'By scanning this QR code, you acknowledge and agree to our ',
            )}
            <AppVideo.PrivacyLink href="/privacy" target="_blank">
              {t(`${TP}.privacyPolicy`, 'Privacy Policy.')}
            </AppVideo.PrivacyLink>
          </AppVideo.QrCodeDisclaimer>
        </AppVideo.QrCodeWrapper>
      </AppVideo.Copy>
    </AppVideo.Content>
  );
};

AppVideo.Content = styled.div`
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 0;
  padding-top: 100%;
  position: relative;

  @media (min-width: ${({ theme }) => theme.breakpoints.medium}px) {
    background-image: url(${BG_IMG_LG});
    padding-top: 56.25%;
  }
`;
AppVideo.Copy = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 16px;
  right: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.medium}px) {
    color: ${({ theme }) => theme.colors.white};
    left: 200px;
  }
`;
AppVideo.Heading = styled.h1`
  letter-spacing: -0.02em;
  font-weight: 400;
  margin-bottom: 16px;
  max-width: 600px;
  -webkit-text-stroke: 0.8px currentColor;
  ${variableFontRegular({ size: '14px', height: '16.8px' })};
`;
AppVideo.SubHeading = styled.h2`
  font-weight: normal;
  letter-spacing: -0.02em;
  margin: 0 0 16px;
  max-width: 250px;
  text-align: left;
  -webkit-text-stroke: 0.8px currentColor;
  ${variableFontRegular({ size: '11.5px', height: '14px' })};

  @media (min-width: ${({ theme }) => theme.breakpoints.medium}px) {
    max-width: 418px;
  }
`;
AppVideo.QrCodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
AppVideo.PrivacyLink = styled.a`
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
  }
`;
AppVideo.QrCodeText = styled(AppVideo.SubHeading)`
  padding-top: 64px;
`;
AppVideo.QrCode = styled(Image)`
  width: 75px;
  height: 75px;
`;
AppVideo.QrCodeDisclaimer = styled.p`
  color: ${({ theme }) => theme.colors.lightGray4};
  ${variableFontRegular({ size: '8.6px', height: '9px' })};
  margin-top: 24px;
  width: 140px;
  text-align: left;
`;
